import { z } from "zod";

export const resolutionEnum = z.enum([
  "refund",
  "exchange",
  "exchange-credit",
  "discount",
]);

export const resolutionOptionEnum = z.enum(["bank-transfer", "discount-code"]);

export const lineItemResolutionSchema = z.object({
  resolution: resolutionEnum,
  resolutionOption: resolutionOptionEnum.nullable().default(null),
  exchangeVariantId: z.string().nullable().default(null),
});

export type LineItemResolutionFormValues = z.infer<
  typeof lineItemResolutionSchema
>;
